export default __webpack_public_path__ + "static/shonda-jones-profile-mobile-741ca00d6f68e334ee3bf0b0c0b53e43.png";